export default "__VITE_ASSET__a8fb4a7a__"